export default __webpack_public_path__ + "assets/models/4d8b0b529db8b14162c195105a8e7df7.glb";